import './Result.scss';
import React, {useContext} from 'react';
import {GlobalContext} from '../../context';
import {priceFormatter} from '../../utils';

export const Result = ({goToContactForm, product, i, updateWishlist, checked, isWishList, afterFormSuccessUrl}) => {
    const {isDarkMode, updateCookies, responseArray} = useContext(GlobalContext);
    const goToForm = () => {
        let cookieString = product.manufacturer.name;
        if (product.bulletPoints && product.bulletPoints[0]) {
            cookieString += ' ' + product.bulletPoints[0] + ' ' + product.pricesFrom + '€';
        }
        parent.postMessage({key: 'elements.user.heating_result', value: cookieString}, '*');
        updateCookies(responseArray);
        goToContactForm({productid: product.id, systemType: product.type, heating_result: cookieString});
    }

    const mapType = (type) => {
        if (type === 'oel_b') {
            return 'Öl Bodenstehend';
        } else if (type === 'gas_w') {
            return 'Gas Wandhängend';
        } else if (type === 'gas_b') {
            return 'Gas Bodenstehend';
        } else {
            return 'Keine Angabe';
        }
    }

    return (
        <div key={i} className="results-page__result col-lg-4 col-sm-12 mt-4">
            <div className="rpr-container p-3">
                <div className="rpr-header d-flex flex-row flex-nowrap mb-3">
                    <img
                        src={'https://portal.thermobox.de/Content/Images/' + product.manufacturer.img}
                        alt={product.label}
                    />
                    {/*<div className="flex-grow-1">&nbsp;</div>*/}
                    {/*<div*/}
                    {/*    className={`rpr-favorite btn ${checked ? 'checked' : ''}`}*/}
                    {/*    onClick={() => updateWishlist(product, !checked)}*/}
                    {/*>*/}
                    {/*    <SVG*/}
                    {/*        src={Icons.favorite}*/}
                    {/*        width="20"*/}
                    {/*        height="20"*/}
                    {/*    />*/}
                    {/*</div>*/}
                </div>
                <div
                    className="rpr-image mb-3"
                    style={{
                        'backgroundImage': 'url(https://portal.thermobox.de/Content/Images/' + product.b2c.productImage + ')'
                    }}
                >
                    &nbsp;
                </div>
                <div className="rpr-content">
                    <div className="rpr-info mb-3">
                        <div className="rpr-info-label mb-1">{product.label}</div>
                        <div className="rpr-info-price">ab {priceFormatter.format(product.pricesFrom)}</div>
                    </div>
                    <div className="rpr-spec mb-3">
                        <div className="rpr-spec-features">
                            <div id={'accordion-' + product.id}>
                                {product.description.map((descriptionEntry, i) => {
                                    return (
                                        <div key={'description-' + product.id + '-' + i}
                                             className="card card-plain">
                                            <div className="card-header" role="tab"
                                                 id={'heading-' + product.id + '-' + i}>
                                                <a data-toggle="collapse" aria-expanded="false" className="collapsed"
                                                   aria-controls={'collapse-' + product.id + '-' + i}
                                                   data-target={'#collapse-' + product.id + '-' + i}>
                                                    <div
                                                        className="card-header-title"> {descriptionEntry.title}</div>
                                                    <i className="fa fa-chevron-down"/>
                                                    <i className="fa fa-chevron-up"/>
                                                </a>
                                            </div>
                                            <div id={'collapse-' + product.id + '-' + i}
                                                 className="collapse" role="tabpanel"
                                                 aria-labelledby={'heading-' + product.id + '-' + i}
                                                 data-parent={'#accordion-' + product.id}>
                                                <div className="card-body">
                                                    {descriptionEntry.bulletPoints && descriptionEntry.bulletPoints.length > 0 &&
                                                        <ul>
                                                            {descriptionEntry.bulletPoints.map((bulletPoint, i) => {
                                                                return (
                                                                    <li className={isDarkMode ? "dark" : ""}
                                                                        key={i}>{bulletPoint}</li>)
                                                            })}
                                                        </ul>
                                                    }
                                                    {!descriptionEntry.bulletPoints &&
                                                        <span>{descriptionEntry.text}</span>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>

                    </div>
                </div>
                <div className="rpr-footer">
                    <button onClick={() => goToForm()}>
                        Jetzt kostenlos anfragen
                    </button>
                </div>
            </div>
        </div>
    );
};
